import { FC } from 'react';
import { NDFFormType } from 'types/ndf';
import NDFExportERPForm from './NDFExportERPForm';
import NDFExportHBRForm from './NDFExportHBRForm';

interface Props {
    type: NDFFormType;
}

const NDFExport: FC<Props> = ({ type }): JSX.Element => {
    const Form = type === 'HBR' ? NDFExportHBRForm : NDFExportERPForm;
    return <Form key={type} />;
};

export default NDFExport;
